import { render, staticRenderFns } from "./counter-view.vue?vue&type=template&id=22490203&"
import script from "./counter-view.vue?vue&type=script&lang=js&"
export * from "./counter-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports